import { HTMLProps } from 'react'

import { TreeInformation } from 'react-complex-tree'

export function TreeContainer({
  containerProps,
  children,
}: {
  children: React.ReactNode
  containerProps: HTMLProps<HTMLDivElement>
  info: TreeInformation
}) {
  return (
    <div>
      <div {...containerProps}>{children}</div>
    </div>
  )
}
